import { useCallback, useEffect, useRef } from "react";
import { useAtom } from "jotai";
import useRecorderContext from "../context/useRecorderContext";
import { currentSceneAtom } from "../atoms/sceneAtoms";
import logger from "../utils/logger";

export default function useRecordingStarter(isReset: boolean = false) {
  const {
    startRecording,
    setShowCountdown,
    enableCountdown,
    stageRef,
    webcamStream,
    screenStream,
  } = useRecorderContext();
  
  // Get currentScene from Jotai atom
  const [currentScene] = useAtom(currentSceneAtom);
  
  const screenStreamRef = useRef(screenStream);
  const webcamStreamRef = useRef(webcamStream);

  useEffect(() => {
    screenStreamRef.current = screenStream;
    webcamStreamRef.current = webcamStream;
  }, [screenStream, webcamStream]);

  const handleStart = useCallback(
    (overrideIsReset: boolean = false) => {
      if (!stageRef?.current) {
        logger.warn("❌ stageRef is not set.");
        return;
      }

      const isPresentationImport = (currentScene as any)?.metadata?.sourceType === 'presentation-import';

      if (enableCountdown) {
        setShowCountdown(true);

        setTimeout(() => {
          if (!isPresentationImport && !screenStreamRef.current && !webcamStreamRef.current) {
            logger.warn("⚠️ [useRecordingStarter] No streams available, canceling recording");
            setShowCountdown(false);
            return;
          }
          logger.info("✅ [useRecordingStarter] Countdown complete, starting recording", {
            sceneId: currentScene?.id,
            sceneTitle: currentScene?.title
          });
          setShowCountdown(false);
          startRecording(overrideIsReset, currentScene?.id);
        }, 3000); // 3 second countdown
      } else {
        logger.info("⏭️ [useRecordingStarter] Countdown disabled, starting recording immediately", {
          sceneId: currentScene?.id,
          sceneTitle: currentScene?.title
        });
        startRecording(overrideIsReset, currentScene?.id);
      }
    },
    [stageRef, enableCountdown, setShowCountdown, startRecording, currentScene]
  );

  return { handleStart };
}
